import { format, isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

import { DateFormats } from '@/constants/date';

export const formatDate = (
  date: Date | number | null,
  dateFormat: string = DateFormats.NumericUS,
  timeZone = 'Etc/UCT',
): string => {
  if (!date || !isValid(date)) {
    return 'Invalid Date';
  }

  switch (dateFormat) {
    case DateFormats.DataBase:
      return (format(date, DateFormats.DataBase) + 'Z').replace(' ', 'T');

    case DateFormats.UTC:
      return (formatInTimeZone(date, timeZone, DateFormats.UTC) + 'Z').replace(' ', 'T');

    case DateFormats.Report:
      return format(date, DateFormats.Report);

    default:
      return formatInTimeZone(date, timeZone, dateFormat);
  }
};

/**
 * @param date ISO string date format
 * */
export const reportDateFormat = (date: string): string => {
  const asDate = new Date(date.replace('Z', ''));

  return formatDate(asDate, DateFormats.Report);
};

export const taskCardDateFormat = (inputDate: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  };
  const date = new Date(inputDate);

  return date.toLocaleDateString('en-US', options);
};

export const rangeDateFormat = (initialDate: string, endDate: string): string => {
  const startDate = new Date(initialDate);
  const finalDate = new Date(endDate);

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  };

  const startDateString = startDate.toLocaleDateString('en-US', options);
  const endDateString = finalDate.toLocaleDateString('en-US', options);

  return `${startDateString} - ${endDateString}`;
};
